import React from "react";

const meios = [
  { nome: "PIX", detalhe: "à vista, com QR code no app" },
  { nome: "Boleto bancário", detalhe: "vencimento definido no pedido" },
  { nome: "Cartão de crédito", detalhe: "parcelado quando o parceiro permite" },
  { nome: "Cartão de débito", detalhe: "à vista" },
];

const extras = [
  {
    titulo: "Cartões salvos",
    texto: "Cadastre uma vez e use nos próximos pedidos sem digitar de novo.",
  },
  {
    titulo: "Comprovante no pedido",
    texto:
      "Todo pagamento gera recibo anexado ao pedido, pronto para compartilhar ou baixar.",
  },
];

const Pagamentos: React.FC = () => (
  <section id="pagamento" className="border-b border-bone-300 bg-white">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16">
        <div>
          <p className="eyebrow">Pagamento</p>
          <h2 className="mt-4 font-display text-display-md font-bold text-soil">
            Pague onde o pedido está.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-soil/75">
            O pagamento acontece dentro do pedido. Nada de comprovante solto no
            WhatsApp nem cobrança que ninguém acha depois.
          </p>

          <dl className="mt-9 space-y-6">
            {extras.map((e) => (
              <div key={e.titulo} className="border-l-2 border-soy pl-4">
                <dt className="font-display text-base font-bold text-soil">
                  {e.titulo}
                </dt>
                <dd className="mt-1.5 text-sm leading-relaxed text-soil/70">
                  {e.texto}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="panel self-start">
          <div className="panel-head">
            <span className="font-mono text-[0.6875rem] uppercase tracking-[0.16em] text-soil/60">
              Meios aceitos
            </span>
          </div>
          <ul className="divide-y divide-bone-200">
            {meios.map((m) => (
              <li key={m.nome} className="flex items-center gap-4 px-4 py-4 sm:px-5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="shrink-0 text-agro-accent"
                  aria-hidden="true"
                >
                  <path d="M3 8.5l3.5 3.5L13 5" />
                </svg>
                <div className="min-w-0">
                  <p className="font-semibold text-soil">{m.nome}</p>
                  <p className="mt-0.5 text-sm text-soil/60">{m.detalhe}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Pagamentos;
